module.exports = __webpack_public_path__ + "static/media/starship-freighter.802f1fad.svg";